export default __webpack_public_path__ + "static/media/slider_image_03-xs@2x.2942fbb0.jpg";